import {
    Component, ElementRef, Input, Renderer2, ViewChild

} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import * as _ from "lodash";
import { MatSort } from '@angular/material/sort';



export interface IDeployedPackagesTable {
    packageName: string;
    scriptName: string;
    action: string;
    status: string;
    viewChanges: string;
}

@Component({
    selector: 'impact-analysis-precheck-errors',
    template: require('./impact-analysis-precheck-errors.html'),
    styles: [require('./impact-analysis-precheck-errors.scss')]
})
export class ImpactAnalysisPrecheckErrorsComponent {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    public policyEnums:any;
    public processData:any;


    public displayedColumns = ['errors', 'package', 'script'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;
    private pressed = false;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;
    @Input() public set items(data: any) {
        if (data) {
            //console.log(data)
            const dataArr = [];
            if(data.preRunTestResultList){
                data.preRunTestResultList.forEach((item) => {
                    dataArr.push({
                        ResultText: item.ResultText,
                        packageName : item.PackageName,
                        scriptName:item.ScriptName ,
                    });
                });
                this.dataSource.data = dataArr;
            }
        }
    }


    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'errors', width: 300 },
        { field: 'package', width: 300 },
        { field: 'script', width: 350 },
    ];

    constructor(private renderer: Renderer2) {
    

    }

    public async ngOnInit() {}



    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);

    }
  private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }
    

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
       // this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }


private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
               // if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
               // }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
           //     this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            // if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            // }
        }   
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

   // @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-precheck-errors-ang7/impact-analysis-precheck-errors.ts